<template>
  <div>
    <basic-container>
      <div>
        <el-form
          ref="form"
          :model="projectServiceForm"
        >
          <el-form-item
            label="工程项目名称"
            label-width="100px"
          >
            <div style="display: flex;width:300px;">
              <el-select
                v-model="projectServiceForm.projectItem"
                placeholder="请选择工程项目名称"
                width="200"
                @change="chooseProjectItem"
                value-key="id"
              >
                <el-option
                  v-for="item in projectItems"
                  :key="item.id"
                  :label="item.name"
                  :value='item'
                ></el-option>
              </el-select>
            </div>
          </el-form-item>
          <el-form-item
            label="预约人姓名"
            label-width="100px"
          >
            <div style="display: flex;width:300px;">
              <el-input
                v-model="projectServiceForm.reservationName"
                placeholder="请选择预约人姓名"
              >
              </el-input>
            </div>
          </el-form-item>
          <el-form-item
            label="预约人电话"
            label-width="100px"
          >
            <div style="display: flex;width:300px;">
              <el-input
                v-model="projectServiceForm.reservationMobile"
                placeholder="请选择预约人电话"
              >
              </el-input>
            </div>
          </el-form-item>
          <el-form-item
            label="服务地址"
            label-width="100px"
          >
            <div style="display: flex;width:300px;">
              <avue-map v-model="point"></avue-map>
            </div>
          </el-form-item>
          <el-form-item
            label="详细地址"
            label-width="100px"
          >
            <div style="display: flex;width:300px;">
              <el-input
                v-model="point.address"
                placeholder="请输入详细地址"
              >
              </el-input>
            </div>
          </el-form-item>
          <el-form-item
            label="服务时间"
            label-width="100px"
          >
            <div style="display: flex;width:300px;">
              <el-date-picker
                v-model="projectServiceForm.serviceTime"
                type="datetime"
                value-format="timestamp"
                placeholder="选择日期时间"
              >
              </el-date-picker>
            </div>
          </el-form-item>
          <el-form-item label="服务预约配置">
            <div>
              <!-- {{dataList}} -->
              <el-table
                :data="dataList"
                border
              >
                <el-table-column
                  prop="name"
                  align="center"
                  label="工程阶段名称"
                >
                  <template slot-scope="scope">
                    <el-input
                      v-model="scope.row.name"
                      disabled
                    >
                    </el-input>
                  </template>

                </el-table-column>
                <el-table-column
                  prop="startTime"
                  align="center"
                  label="工程开始时间"
                >
                  <template slot-scope="scope">
                    <el-date-picker
                      :disabled="scope.row.disabled"
                      v-model="scope.row.startTime"
                      @change="blurKey"
                      type="datetime"
                      placeholder="选择工程开始时间"
                      value-format="timestamp"
                      default-time="12:00:00"
                    >
                    </el-date-picker>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="endTime"
                  align="center"
                  label="工程结束时间"
                >
                  <template slot-scope="scope">
                    <el-date-picker
                      :disabled="scope.row.disabled"
                      v-model="scope.row.endTime"
                      @change="blurKey"
                      type="datetime"
                      placeholder="选择工程结束时间"
                      value-format="timestamp"
                      default-time="12:00:00"
                    >
                    </el-date-picker>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="workerUserId"
                  align="center"
                  label="工程师"
                >
                  <template slot-scope="scope">
                    <el-select
                      :disabled="scope.row.disabled"
                      v-model="scope.row.workerUserId"
                      placeholder="请选择服务人员"
                      filterable
                      clearable
                      remote
                      :remote-method="remoteMethod"
                      @change="blurKey"
                    >
                      <el-option
                        v-for="item2 in currservicePeoples"
                        :key="item2.id"
                        :label="item2.realName"
                        :value="item2.id"
                      ></el-option>
                    </el-select>
                  </template>
                </el-table-column>
              </el-table>

            </div>
          </el-form-item>
          <el-form-item
            label="备注信息"
            label-width="100px"
          >
            <div style="display: flex;width:300px;">
              <el-input
                v-model="projectServiceForm.remarks"
                placeholder="请填写工程的备注信息"
              >
              </el-input>
            </div>
          </el-form-item>
        </el-form>
        <div style='width:100%;display:flex;flex-flow:row nowrap;justify-content: center;margin-top:50px;margin-bottom:50px'>
          <el-button
            type="primary"
            size="big"
            @click="submit"
          >确定新增</el-button>
        </div>
      </div>
    </basic-container>
  </div>
</template>

<script>
import { DIC } from "@/const/dic";
import { resolveUrlPath, setUrlPath } from "@/util/util";
import { getAliyunPublicToken } from "@/api/oss/aliyun";
import oss from "ali-oss";
import md5 from "js-md5";
import {
  findProject,
  addEngineeringOrder,
  findEngineeringProjectFindAll,
  findEngineeringProjectId,
  findUserList,
  findUsersByUserTypeAll,
} from "@/api/work/projectService";

export default {
  data() {
    return {
      users: [],
      dataList: [],
      projectItems: [],
      joinsWorkServiceItems: [],
      point: {},
      currservicePeoples: [],
      fileList: [],
      tableData1: {},
      clientTypes: DIC.SERVICEITEM_TYPE,
      superiorIds: [],
      categoryTypes: [],
      currIndex: "",
      projectServiceForm: {},
      isTop: "YES",
      yyTypes: DIC.SERVICEITEM_YYTYPE,
      types: DIC.SERVICE_WARRANTY_DATE_TYPE,
      tableData: [],
      disabled: true,
    };
  },
  created() {
    let params = {};
    params.userType = "JOINS_ENGINEER";
    findUsersByUserTypeAll(params).then((res) => {
      let data = JSON.parse(res.data);
      this.users = data.rows;
      for (let i = 0; i < this.users.length; i++) {
        let obj = this.users[i];
        obj.shouName = obj.realName + "(" + obj.mobile + ")";
      }
      // console.log("数据:"+JSON.stringify(this.users))
    });
    findEngineeringProjectFindAll().then((res) => {
      let data = JSON.parse(res.data);
      this.projectItems = data;
    });
    findProject().then((res) => {
      let data = JSON.parse(res.data);
      this.superiorIds = data;
    });
  },
  methods: {
    remoteMethod(query) {
      console.log(query);
      if (query.length == 5) {
        this.currservicePeoples = [];
        setTimeout(() => {
          //   this.loading = false;
          let params = {
            type: "JOINS_ENGINEER",
            mobile: query,
          };
          findUserList(params).then((res) => {
            console.log(res);
            if (res.code == "200") {
              let data = JSON.parse(res.data);
              console.log(data);
              this.currservicePeoples = data;
            } else {
              this.$message({
                showClose: true,
                message: res.message,
                type: "error",
              });
            }
          });
        }, 200);
      } else if (query.length == 11) {
        // this.loading = true;
        this.currservicePeoples = [];
        setTimeout(() => {
          //   this.loading = false;
          let params = {
            type: "JOINS_ENGINEER",
            mobile: query,
          };
          findUserList(params).then((res) => {
            console.log(res);
            let data = JSON.parse(res.data);
            this.currservicePeoples = data;
          });
        }, 200);
      } else {
        this.classifySelects = [];
      }
    },
    choseServiceItem(e) {
      console.log(e);
    },
    chooseProjectItem(e) {
      console.log(e);
      findEngineeringProjectId(e.id).then((res) => {
        let data = JSON.parse(res.data);
        console.log(data);
        //obj.startTime!=''&&obj.endTime!=''&&obj.workerUserId!=''

        for (let i = 0; i < data.length; i++) {
          data[i].startTime = "";
          data[i].endTime = "";
          data[i].workerUserId = "";
          if (i == 0) {
            data[i].disabled = false;
          } else {
            data[i].disabled = true;
          }
        }
        this.dataList = data;
        console.log(this.dataList, 99999);
        // let dataList = [];
        // for (let i = 0; i < data.projectChannelList.length; i++) {
        //   let arr = [];
        //   let obj = {};
        //   obj.id = data.projectChannelList[i].id;
        //   obj.clientType = data.projectChannelList[i].clientType;

        //   let inDataList = [];
        //   for (
        //     let j = 0;
        //     j < data.projectChannelList[i].projectList.length;
        //     j++
        //   ) {
        //     let inarr = [];
        //     let inobj = {};
        //     inobj.id = data.projectChannelList[i].projectList[j].id;
        //     inobj.name = data.projectChannelList[i].projectList[j].name;
        //     inobj.dynamics = data.projectChannelList[i].projectList[j].dynamics;
        //     inarr.push(inobj);
        //     inDataList.push(inarr);
        //     for (
        //       let k = 0;
        //       k < data.projectChannelList[i].projectList[j].dynamics.length;
        //       k++
        //     ) {
        //       data.projectChannelList[i].projectList[j].dynamics[k].inputType =
        //         data.projectChannelList[i].projectList[j].dynamics[k]
        //           .inputType + "";
        //     }
        //   }
        //   obj.projectList = inDataList;
        //   arr.push(obj);
        //   dataList.push(arr);
        // }
        // this.dataList = dataList;
      });
    },
    selectSuperiorId(e) {
      console.log(e);
      let params = {};
      params.superiorId = e;
      findProject(params).then((res) => {
        console.log(res);
        let data = JSON.parse(res.data);
        this.categoryTypes = data;
      });
    },
    selectCategory(e) {
      console.log(e);
      if (e.channel == null) {
        this.$message({
          showClose: true,
          message: e,
          type: "error",
        });
        return;
      }
      let list = e.channel.split(",");
      let obj = {};
      for (let i in list) {
        console.log(e.configs[i]);
        let dtobj = {};
        dtobj.clientType = e.configs[i].clientType;
        dtobj.agentId = e.configs[i].agentId;
        dtobj.configId = e.configs[i].id;
        dtobj.area =
          (e.configs[i].provinceName == null ? "" : e.configs[i].provinceName) +
          (e.configs[i].cityName == null ? "" : e.configs[i].cityName) +
          (e.configs[i].areaName == null ? "" : e.configs[i].areaName);
        list[i] = [];
        list[i].push(dtobj);
        obj[i] = list[i];
      }
      console.log(list);
      console.log(obj);
      this.tableData1 = obj;
    },
    isIndex(e) {
      console.log(e);
      console.log(this);
      this.currIndex = e;
    },
    handleRemove(file, fileList) {
      console.log(this);
      console.log(file, fileList);
      this.fileList = fileList;
    },
    handlePreview(file) {
      console.log(file);
    },
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${
          files.length + fileList.length
        } 个文件`
      );
    },
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`);
    },

    submit() {
      console.log(this.dataList, 11111);
      let item = {
        close: true,
        label: "新增工程服务",
        value: "/work/projectService/add",
      };
      let params = {};
      console.log(this.projectServiceForm);
      if (this.projectServiceForm.projectItem) {
        params.engineeringProjectId = this.projectServiceForm.projectItem.id;
      } else {
        this.$message({
          showClose: true,
          message: "请选择工程项目名称",
          type: "error",
        });
      }
      params.reservationName = this.projectServiceForm.reservationName;
      params.reservationMobile = this.projectServiceForm.reservationMobile;
      params.serviceStartTime = this.projectServiceForm.serviceTime;
      params.remarks = this.projectServiceForm.remarks;
      params.reservationChannel = "JOINS_AGENT";
      let dataList = [];
      for (let i of this.dataList) {
        console.log(i);
        let obj = {};
        obj.engineeringProjectId = i.id;
        obj.startTime = i.startTime;
        obj.endTime = i.endTime;
        obj.workUserId = i.workerUserId;
        dataList.push(obj);
      }
      params.configureList = dataList;

      if (this.point.location && this.point.pname) {
        params.province = this.point.pname;
        params.city = this.point.cityname;
        params.area = this.point.adname;
        params.address = this.point.address;
        params.latitude = this.point.location.lat;
        params.longitude = this.point.location.lng;
      } else {
        this.$message({
          showClose: true,
          message: "请选择服务地址",
          type: "error",
        });
      }
      console.log(params);
      addEngineeringOrder(params).then(res => {
        console.log(res);
        if (res.code == "200") {
          this.$message({
            showClose: true,
            message: "编辑成功",
            type: "success"
          });
          if (!this.isPas) {
            this.$store.commit("DEL_TAG", item);
            let obj = {
              value: "/work/projectService",
              label: "工程服务管理"
            };
            this.$router.push({
              path: resolveUrlPath(obj.value, obj.label),
              query: obj.query
            });
            this.isPas = true;
          }
        } else {
          if (!this.isPas) {
            this.$message({
              showClose: true,
              message: res.message,
              type: "error"
            });
            this.isPas = true;
            setTimeout(() => {
              this.isPas = false;
            }, 1000);
          }
        }
      });
      // for(let i = 0; i < this.dataList.length;i++){
      //   if(this.dataList[i+1].startTime<this.dataList[i].endTime){
      //     this.$message({
      //     showClose: true,
      //     message: "工程开始时间不能小于上阶段工程结束时间",
      //     type: "error",
      //   });
      //   }
      // }
    },
    handleSteppingDelete(index, row) {
      //   this.propertiesList.splice(index, 1);

      this.tableData.splice(index, 1);
    },
    blurKey() {
      console.log(this.dataList);
      let flag = false;
      let count=0;
      for (let i = 0; i < this.dataList.length; i++) {
        let obj = this.dataList[i];
        console.log( 
          obj.endTime,"数据");
        if (
          obj.startTime != "" &&  obj.startTime != 'null'&&
          obj.endTime != "" &&  obj.endTime != 'null'&&
          obj.workerUserId != ""
        ) {
          console.log("进入");
          flag = true;
          count++;
        }
        if (i>count-1&&flag) {
          console.log("改变"+i)
          obj.disabled = false;
          flag=false;
        }
        if(obj.startTime == "" ||obj.startTime == null  ||
          obj.endTime == "" ||  obj.endTime == null ||
          obj.workerUserId == ""){
            if(i<this.dataList.length){
               for(let j=i+1; j<this.dataList.length; j++){
                let obj1= this.dataList[j];
                 obj1.startTime="";
                  obj1.endTime="";
                  obj1.workerUserId="";
                  obj1.disabled = true;
               }
               return;
            }
          }
        
      }
    },
    handleAddRows(index, row) {
      console.log(index, row);
      let list = {
        yyType: "",
        id: "",
        name: "",
        amount1: "",
        amount2: "",
        amount3: "",
      };
      this.tableData.push(list);
    },
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 8) {
        if (rowIndex % 100 === 0) {
          return {
            rowspan: 100,
            colspan: 1,
          };
        } else {
          return {
            rowspan: 0,
            colspan: 0,
          };
        }
      }
    },
    async fnUploadDescribeImgs(option) {
      this.tableLoading = true;
      console.log(option);
      var obj = {};
      obj.name = option.file.name;
      getAliyunPublicToken().then((res) => {
        let data = JSON.parse(res.data);
        let client = new oss({
          region: data.point,
          endPoint: data.point,
          accessKeyId: data.accessKeyId,
          accessKeySecret: data.accessKeySecret,
          Expiration: data.expiration,
          bucket: data.bucketName,
          stsToken: data.securityToken,
        });
        const storeAs = md5(option.file.name) + new Date().getTime();
        client
          .multipartUpload(storeAs, option.file, {})
          .then((results) => {
            console.log(results);
            let res = results.res.requestUrls;
            let files = new Array();
            for (let url in res) {
              let file = new Object();
              file.label = storeAs;
              file.value = url;
              files.push(file);
            }
            // this.fileList = files;
            let array = results.res.requestUrls[0].split("?");
            obj.url = array[0];
            console.log(obj);
            //上传多张图片
            // if (this.tableData1[this.currIndex][0].image == undefined) {
            //   this.tableData1[this.currIndex][0].image = array[0];
            // } else {
            //   let aa = "";
            //   this.tableData1[this.currIndex][0].image = aa.concat(
            //     this.tableData1[this.currIndex][0].image,
            //     ",",
            //     array[0]
            //   );
            //   console.log(this.tableData1[this.currIndex][0].image);
            // }
            // 上传单张图片
            this.tableData1[this.currIndex][0].image = array[0];
            // this.fileList.push(obj);
            this.describeImgs.push(array[0]);
            this.tableLoading = false;
          })
          .catch((err) => {});
      });
    },
  },
};
</script>

<style>
</style>